"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var FolderOpen_1 = __importDefault(require("@mui/icons-material/FolderOpen"));
var schemaTypes_1 = require("../../../shared/types/schemaTypes");
var IconComponent_1 = __importDefault(require("../../../shared/components/FormComponents/IconComponent"));
var CrudeForeignEntitySelection_1 = __importDefault(require("./utils/CrudeForeignEntitySelection"));
var configurationTypes_1 = require("../../../shared/types/configurationTypes");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var getColumnEditLayout_1 = __importDefault(require("../../../shared/util/getColumnEditLayout"));
var DropDownComponent_1 = __importDefault(require("../../../shared/components/FormComponents/DropDownComponent"));
var loadListEntityData_1 = __importDefault(require("../../../fetch/loadListEntityData"));
var getFetchHeaders_1 = __importDefault(require("../../../shared/util/getFetchHeaders"));
var getDefaultTableFilterSettings_1 = __importDefault(require("../../../defaults/getDefaultTableFilterSettings"));
var commonTypes_1 = require("../../../shared/types/commonTypes");
var translateMessage_1 = __importDefault(require("../../../shared/util/translateMessage"));
var messageTypes_1 = require("../../../shared/types/messageTypes");
var crudeActions = __importStar(require("../../../store/crude/crude.actions"));
var CrudeSimulateDisabledTextInputComponent_1 = __importDefault(require("./CrudeSimulateDisabledTextInputComponent"));
var crude_actions_1 = require("../../../store/crude/crude.actions");
var CrudeDialogComponent_1 = __importDefault(require("../../../shared/components/CrudeComponents/CrudeDialogComponent"));
var DataEditView_1 = __importDefault(require("../DataEditView"));
var CrudeForeignReferenceComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var dispatch = react_redux_1.useDispatch();
    var columnName = props.schema.name;
    var entity = props.entity;
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var editLayout = react_redux_1.useSelector(crude_selector_1.getEditLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var entitySchema = crudeSchema &&
        crudeSchema.find(function (schema) { return schema.name === entity; });
    var _h = react_1.useState(props.columnEditLayout || (editLayout && getColumnEditLayout_1.default(entity, columnName || '', editLayout))), columnEditLayout = _h[0], setColumnEditLayout = _h[1];
    react_1.useEffect(function () {
        setColumnEditLayout(props.columnEditLayout);
    }, [props.columnEditLayout]);
    var fetchHeaders = crudeConfig.api.headers ? getFetchHeaders_1.default(crudeConfig.api.headers) : {};
    var columnLabels = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[props.entity]) === null || _b === void 0 ? void 0 : _b.columns;
    var label = (columnLabels && ((_c = columnLabels[columnName]) === null || _c === void 0 ? void 0 : _c.title)) ? (_d = columnLabels[columnName]) === null || _d === void 0 ? void 0 : _d.title : columnName;
    var description = columnLabels && ((_e = columnLabels[columnName]) === null || _e === void 0 ? void 0 : _e.description);
    var targetEntity = props.schema.outgoingReference && props.schema.outgoingReference.targetEntity;
    var tableFilterSettings = __assign({}, (targetEntity && storedTableFilterSettings[targetEntity][0]) || getDefaultTableFilterSettings_1.default(appLayout));
    tableFilterSettings.pageSize = appLayout.maxDropdownSize || 100;
    var _j = react_1.default.useState((columnEditLayout && columnEditLayout.layout)
        ? columnEditLayout.layout
        : (((_f = appLayout.globalInputLayouts) === null || _f === void 0 ? void 0 : _f.foreignEntity) ? (_g = appLayout.globalInputLayouts) === null || _g === void 0 ? void 0 : _g.foreignEntity : configurationTypes_1.ForeignEntityLayout.popUp)), layout = _j[0], setLayout = _j[1];
    var _k = react_1.default.useState(props.data), data = _k[0], setData = _k[1];
    var _l = react_1.useState(), value = _l[0], setValue = _l[1];
    var _m = react_1.default.useState(), outgoingReferenceData = _m[0], setOutgoingReferenceData = _m[1];
    var _o = react_1.useState(false), selectForeignEntity = _o[0], setSelectForeignEntity = _o[1];
    var _p = react_1.useState(), options = _p[0], setOptions = _p[1];
    var _q = react_1.useState(), message = _q[0], setMessage = _q[1];
    react_1.useEffect(function () {
        if (message && crudeLabels) {
            var text = translateMessage_1.default(message.message, crudeLabels, props.entity);
            var newMessage = {
                eventType: message.eventType,
                severity: message.status && message.status >= 400 ? messageTypes_1.Severity.error : messageTypes_1.Severity.success,
                message: text,
            };
            message && dispatch(crudeActions.addMessage(newMessage));
        }
    }, [message]);
    react_1.useEffect(function () {
        if (JSON.stringify(props.data) !== JSON.stringify(data)) {
            setData(props.data);
            loadForeignEntityData();
        }
    }, [props.data]);
    var changeData = function (value, preview) {
        var newData = data;
        var newColumnData = newData.data;
        if (props.schema.columnType === schemaTypes_1.ColumnType.Number) {
            newColumnData[columnName] = (value && typeof value === 'string') ? parseInt(value, 10) : value;
        }
        else {
            newColumnData[columnName] = value;
        }
        newData.data = newColumnData;
        if (value && props.schema.outgoingReference && props.schema.outgoingReference.targetEntity && preview) {
            if (!newData.entityReferencePreviews[props.schema.outgoingReference.targetEntity]) {
                newData.entityReferencePreviews[props.schema.outgoingReference.targetEntity] = {};
            }
            newData.entityReferencePreviews[props.schema.outgoingReference.targetEntity][value] = preview;
        }
        setData(__assign({}, newData));
        props.onChange && props.onChange(newData);
    };
    var loadForeignEntityData = function () {
        targetEntity && loadListEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, targetEntity, fetchHeaders, tableFilterSettings, undefined, undefined, setOutgoingReferenceData, setMessage, ['include_self_previews']);
    };
    react_1.useEffect(function () {
        var _a, _b;
        if (props.layoutOverwrite) {
            setLayout(props.layoutOverwrite);
        }
        else {
            if (outgoingReferenceData && outgoingReferenceData.totalElements <= tableFilterSettings.pageSize) {
                setLayout((columnEditLayout && columnEditLayout.layout)
                    ? columnEditLayout.layout
                    : (((_a = appLayout.globalInputLayouts) === null || _a === void 0 ? void 0 : _a.foreignEntity) ? (_b = appLayout.globalInputLayouts) === null || _b === void 0 ? void 0 : _b.foreignEntity : configurationTypes_1.ForeignEntityLayout.popUp));
            }
            else {
                setLayout(configurationTypes_1.ForeignEntityLayout.popUp);
            }
        }
        if (outgoingReferenceData && props.schema.outgoingReference && targetEntity) {
            var dataOpt_1 = [];
            // Object.keys(outgoingReferenceData.entityReferencePreviews[targetEntity]).map((referenceKey: string | number) => {
            outgoingReferenceData.data.map(function (elem) {
                var _a, _b;
                var ref = (entitySchema && ((_a = elem[entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.idColumn]) === null || _a === void 0 ? void 0 : _a.toString())) || '';
                // erster Fall wäre ein Element mit id, zweiter Fall, die Voreinstellung eines neuen Elementes (kommt von den outgoingRefs bei einer Entity)
                var val = data.data[columnName] || (((_b = props.embeddingEntityFilter) === null || _b === void 0 ? void 0 : _b.value) && columnName === props.embeddingEntityFilter.key);
                if (val && val.toString() === ref) {
                    setValue({
                        key: ref,
                        value: outgoingReferenceData.entityReferencePreviews[targetEntity][ref],
                    });
                }
                dataOpt_1.push({
                    key: ref,
                    value: outgoingReferenceData.entityReferencePreviews[targetEntity][ref],
                });
            });
            setOptions(dataOpt_1);
        }
    }, [outgoingReferenceData]);
    var _r = react_1.default.useState(), singleEntity = _r[0], setSingleEntity = _r[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        layout === configurationTypes_1.ForeignEntityLayout.autocomplete && options &&
            react_1.default.createElement(DropDownComponent_1.default, { description: description, disableClearable: !props.schema.nullable, options: options, value: value, label: label, fullWidth: props.fullWidth, onChange: function (value) {
                    value
                        ? changeData(value.key, value.value)
                        : changeData(null);
                } }),
        layout !== configurationTypes_1.ForeignEntityLayout.autocomplete &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CrudeSimulateDisabledTextInputComponent_1.default, { showTooltip: true, embeddingEntityFilter: props.embeddingEntityFilter, schema: props.schema, id: props.id, entity: props.entity, data: data, fullWidth: props.fullWidth, clearable: props.schema.nullable, disabled: true, onChange: function (newData) { return setData(newData); }, onClick: function () {
                        var _a, _b, _c;
                        dispatch(crude_actions_1.setShowDialog(true));
                        setSingleEntity({
                            entity: ((_a = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.outgoingReferences.find(function (ref) { return ref.sourceColumn === props.schema.name; })) === null || _a === void 0 ? void 0 : _a.targetEntity) || '',
                            id: ((_b = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.outgoingReferences.find(function (ref) { return ref.sourceColumn === props.schema.name; })) === null || _b === void 0 ? void 0 : _b.sourceColumn) ? data.data[((_c = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.outgoingReferences.find(function (ref) { return ref.sourceColumn === props.schema.name; })) === null || _c === void 0 ? void 0 : _c.sourceColumn) || ''] : undefined,
                        });
                    }, endIcon: react_1.default.createElement(IconComponent_1.default, { icon: react_1.default.createElement(FolderOpen_1.default, null), onClick: function () {
                            setSelectForeignEntity(true);
                        } }) }),
                selectForeignEntity && props.schema.outgoingReference &&
                    react_1.default.createElement(CrudeForeignEntitySelection_1.default, { schema: props.schema, entity: entity, id: props.id, data: data, foreignEntityLayout: layout, outgoingReference: props.schema.outgoingReference, onClose: function () { return setSelectForeignEntity(false); }, onSelectForeignEntity: function (id, preview) {
                            setSelectForeignEntity(false);
                            changeData(id, preview);
                        } })),
        singleEntity &&
            react_1.default.createElement(CrudeDialogComponent_1.default, { onClose: function () {
                    dispatch(crude_actions_1.setShowDialog(false));
                }, content: react_1.default.createElement(DataEditView_1.default, { embeddingEntityFilter: props.embeddingEntityFilter, dataViewType: commonTypes_1.DataViewType.simpleView, entity: singleEntity.entity, id: singleEntity.id ? singleEntity.id : undefined, treeViewLevel: props.treeViewLevel ? props.treeViewLevel + 1 : 1, hideBackButton: true, showInPopup: true, onChangeCrudeSingleEntityData: function (newData) {
                        var _a, _b;
                        var idColumn = (_a = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.outgoingReferences.find(function (ref) { return ref.sourceColumn === props.schema.name; })) === null || _a === void 0 ? void 0 : _a.targetColumn;
                        var id = newData.data && idColumn ? newData.data[idColumn] : undefined;
                        var targetEntity = (_b = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.outgoingReferences.find(function (ref) { return ref.sourceColumn === props.schema.name; })) === null || _b === void 0 ? void 0 : _b.targetEntity;
                        var preview = targetEntity && id && newData.entityReferencePreviews[targetEntity] ? newData.entityReferencePreviews[targetEntity][id] : undefined;
                        changeData(id, preview);
                    } }) })));
};
exports.default = CrudeForeignReferenceComponent;
